import React from 'react';
import Icon from '../../../../muiComponents//Icon';
import Tooltip from '../../../../muiComponents/Tooltip';
import { getCSSVariable } from '../../../../stylesheets/cssVariablesUtils';

const StarRating = ({ rating, max = 6, title }) => {
    const stars = [];
    const style = {
        color: getCSSVariable('accentColorOrange400'),
    };

    for (let i = 1; i <= max; i++) {
        if (i <= rating) {
            stars.push(<Icon key={i} iconName='Star' style={style} />);
        } else if (i - rating <= 0.5) {
            stars.push(<Icon key={i} iconName='StarHalf' style={style} />);
        } else {
            stars.push(<Icon key={i} iconName='StarOutline' style={style} />);
        }
    }

    return (
        <Tooltip title={title}>
            <div className='flex width-content'>{stars}</div>
        </Tooltip>
    );
};

export default StarRating;
